"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M11.4995 7.091c0 1.6-1.125 2.909-2.5 2.909s-2.5-1.309-2.5-2.909c0-1.6 2.5-5.091 2.5-5.091s2.5 3.491 2.5 5.091zm10.5 4.909-5-3.25v2.5856c-2.9588.813-5.3108 3.009-7 5.4981V13.5h-2V20h-6v2h20v-2H10.4657c1.3615-2.7837 3.5253-5.4986 6.5338-6.5672V15.25l5-3.25z"
  })];
};

exports.default = _default;